export const isPending3DApproval = (status?: string | null): boolean => status === 'Need 3D Approval';

export const has3DApprovalActivity = (status?: string | null): boolean =>
    status === 'Need 3D Approval' || status === 'Approved' || status === 'Rejected';

export interface ThreeDApprovalLabelInput {
    name?: string | null;
    product_description?: string | null;
}

export const getLineItemLabel = (item?: ThreeDApprovalLabelInput | null): string => {
    if (!item) return '';

    const name = item.name && item.name !== 'CNC Part' ? item.name.trim() : '';

    if (name) return name;

    return (item.product_description ?? '').trim();
};
